import moment from "moment";

export const DateFormatter = (date, ...rest) => {
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
};


export const DateFormatterWithAMPM = (date, ...rest) => {
    return moment(date).format('YYYY-MM-DD HH:mm:ss A');
};

export const DateFormatterWithoutTime = (date, ...rest) => {
    return moment(date).format('YYYY-MM-DD');
};